import { render, staticRenderFns } from "./MapEventCatalogLocations.component.vue?vue&type=template&id=1b6d61ce"
import script from "./MapEventCatalogLocations.component.vue?vue&type=script&lang=ts"
export * from "./MapEventCatalogLocations.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports